import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import AdminLayout from "./layouts/AdminLayout";

// Code splitting: Lazy load de todas las páginas
// ============================================================================
// INICIO: MODO MANTENIMIENTO
// TODO: Remover estas importaciones y el componente ConditionalLanding cuando
// ya no sea necesario el modo de mantenimiento
// ============================================================================
// const ConditionalLanding = lazy(() => import("@components/ConditionalLanding"));
// const Proximamente = lazy(() => import("@pages/proximamente"));
// ============================================================================
// FIN: MODO MANTENIMIENTO
// ============================================================================

const LandingPage = lazy(() => import("@pages/landingPage"));
const LoginScreen = lazy(() => import("@pages/admin/login"));
const CreatePostcard = lazy(() => import("@pages/createPostcard"));
const AdminHome = lazy(() => import("@pages/admin/home"));
const ChallengeTable = lazy(() => import("@pages/admin/challenge"));
const PostcardsGallery = lazy(() => import("@pages/postcards-gallery"));
const ChallengeParticipation = lazy(() => import("pages/admin/participations"));
const ChallengeEdit = lazy(() => import("@pages/admin/editChallengePage"));
const ChallengeCreate = lazy(() => import("@pages/admin/createChallengePage"));
const ChallengePostcards = lazy(() => import("@pages/admin/postcardsPage"));
const AdministratorTableDashboard = lazy(() => import("@pages/admin/administrators"));
const CreateUsersPage = lazy(() => import("@pages/admin/createUsersPage"));
const SponsorsTable = lazy(() => import("@pages/admin/sponsors"));

// Componente de fallback para loading
const LoadingFallback = () => {
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => setShow(true), 200);
    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      backgroundColor: '#F5F5F5'
    }}>
      <img 
        src={require("./assets/LoadingIcon.gif")} 
        alt="Cargando..." 
        style={{ width: '50px', height: '50px' }}
      />
    </div>
  );
};

function App() {
  return (
    <div>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          {/* ==================================================================== */}
          {/* INICIO: MODO MANTENIMIENTO */}
          {/* 
            La ruta "/" ahora usa ConditionalLanding que verifica si el usuario
            viene de "/testing-new-changes". Si viene de esa URL, muestra la 
            landing real, si no, muestra la página "Próximamente".
            
            PARA REVERTIR:
            1. Cambiar <ConditionalLanding /> por <LandingPage />
            2. Eliminar la ruta "/testing-new-changes"
            3. Eliminar la importación de ConditionalLanding y Proximamente
            4. Eliminar el componente ConditionalLanding y la página Proximamente
          */}
          {/* ==================================================================== */}
          <Route path="/" element={<LandingPage />} />
          {/*<Route path="/testing-new-changes" element={<LandingPage />} />*/}
          {/* ==================================================================== */}
          {/* FIN: MODO MANTENIMIENTO */}
          {/* ==================================================================== */}
          <Route path="/admin" element={<LoginScreen />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="home" element={<AdminHome />} />
            <Route path="challenge" element={<ChallengeTable />} />
            <Route path="challenge/createChallenge" element={<ChallengeCreate />} />
            <Route path="challenge/:id" element={<ChallengeEdit />} />
            <Route path="participantes" element={<ChallengeParticipation />} />
            <Route path="administradores" element={<AdministratorTableDashboard />} />
            <Route path="postales-creadas" element={<ChallengePostcards />} />
            <Route path="user/createUser" element={<CreateUsersPage />} />
            <Route path="sponsors" element={<SponsorsTable />} />
          </Route>
          <Route path="/crear-postal" element={<CreatePostcard />} />
          <Route path="/galeria" element={<PostcardsGallery />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
